import { z } from 'zod';
import { transformAndFilterValidItems } from '../../../common/tools/transformUtils';

// Application schema for validating each application object
export const ApplicationSchema = z
    .object({
        id: z.string(),
        key: z.string(),
        name: z.string(),
    })
    .describe('ApplicationSchema');

// ApplicationSegment schema for validating application segments and their nested applications
export const ApplicationSegmentSchema = z
    .object({
        id: z.string(),
        key: z.string(),
        name: z.string(),
        // HubspotYageoContactUsApplicationSegment brick (if not attached - nulls or `enabled` is false,
        // application segment will not be shown in the form)
        hubspotYageoContactUs_enabled: z
            .boolean()
            .nullable()
            .transform((v) => v ?? false),
        hubspotYageoContactUs_fieldValue: z.string().nullable(),
        applications: z
            .array(z.unknown())
            .transform((apps) => transformAndFilterValidItems(ApplicationSchema, apps)),
    })
    .superRefine((data, ctx) => {
        if (
            data.hubspotYageoContactUs_enabled === true &&
            (data.hubspotYageoContactUs_fieldValue == null ||
                data.hubspotYageoContactUs_fieldValue.trim() === '')
        ) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message:
                    '`hubspotYageoContactUs_fieldValue` is required when `hubspotYageoContactUs_enabled` is true.',
                path: ['hubspotYageoContactUs_fieldValue'],
            });
        }
    })
    .describe('ApplicationSegmentSchema');

// Main schema to validate the entire query response
export const GetProductApplicationSegmentListingSchema = z
    .object({
        getObjectFolder: z.object({
            children: z
                .array(z.unknown()) // Allow any items in the array initially
                .transform((segments) =>
                    transformAndFilterValidItems(ApplicationSegmentSchema, segments)
                ),
        }),
    })
    .describe('GetProductApplicationSegmentListingSchema');
